<div class="affichage-liste-trajets">
	@if (enChargement()) {
		<div class="spinner">
			<div class="app-spinner"></div>
		</div>
	} @else {
		@for (date of datesTrajets; track date) {
			<div class="section-journee">
				@if (!estAffichageMobile()) {
					<div class="journee">{{ date | date:'EEEE dd/MM' | premiereLettreMajusculePipe }}</div>
				}
				@for (trajet of mapTrajets().get(date); track trajet) {
					<app-carte-trajet [trajet]="trajet"
					                  [delaiLimiteReservationApresDepart]="delaiLimiteReservationApresDepart()"
					                  [cliqueDesactiveSiTrajetPasse]="cartesDesactiveesSiTrajetPasse()">
					</app-carte-trajet>
				}
			</div>
		} @empty {
			<div class="aucun-trajet">{{ messageAucunTrajet() | translate }}</div>
		}
	}
</div>
